import { Link } from 'react-router-dom';

import { MDText } from 'i18n-react';

import { Button, ButtonOwnProps } from '@motorway/mw-highway-code';

import { VEHICLE_COLLECTION_ROUTE } from 'Utilities/routing';

import { useVehicleCollectionSub } from 'Containers/app/vehicleCollection/hooks/useVehicleCollectionSub';

import LocalTexts from './BackToPostSaleSummaryButton.texts.json';

const LocalT = new MDText(LocalTexts);

export const BackToPostSaleSummaryButton = ({ variant = 'secondary' }: { variant?: ButtonOwnProps['variant']} = {}) => {
  // We redirect to collection page, which will act
  // as a router. Should we need tp show dealer summary page
  // collection page will redirect to it
  const url = `/${useVehicleCollectionSub().vrm}${VEHICLE_COLLECTION_ROUTE}`;

  return (
    <Button fullWidth reverse as={Link} label={LocalT.translate('label')} to={url} variant={variant} />
  );
};
